export default function initEntreprises () {
  const $blocks = document.querySelectorAll('.wp-block-entreprises')
  $blocks.forEach($block => {
    // eslint-disable-next-line no-new
    new Entreprises($block)
  })
}

/**
 *
 * @param {HTMLElement} $el HTML Element
 */
class Entreprises {
  constructor (element) {
    this.$el = element
    this.$button = this.$el.querySelector('.js-reveal-entreprises')
    this.init()
  }

  init () {
    if (this.$button) {
      this.$button.addEventListener('click', () => {
        const itemsToShow = this.$el.querySelectorAll('.item--hidden')

        itemsToShow.forEach(item => {
          item.classList.remove('item--hidden')
          item.classList.add('item--active')
        })

        this.$button.style.display = 'none'
      })
    }
  }
}
